export default "__VITE_ASSET__BluQt9N1__"